module.exports = __webpack_public_path__ + "static/016.thumb-9f82ea936e7d9231e9d9f60363663951.jpg";